<template>
  <div class="sign">
    <div class="sign_head">学生签字</div>
    <template v-if="!isInvalid">
      <div class="sign_panel sign_info">
        <div class="sign_item">
          <div class="sign_item-label">
            <img class="sign_icon" src="../../assets/images/sign/icon-ckdh.png" alt="">出库单号：
          </div>
          <div class="sign_info-val">
            {{data.outCode}}
          </div>
        </div>
        <template v-for="item in data.outputDetails">
          <div class="sign_item">
            <div class="sign_item-label">
              <img class="sign_icon" src="../../assets/images/sign/icon-pmmc.png" alt="">品目名称：
            </div>
            <div class="sign_info-val">
              {{item.itemName}}
            </div>
          </div>
          <div class="sign_item">
            <div class="sign_item-label">
              <img class="sign_icon" src="../../assets/images/sign/icon-fhsl.png" alt="">发货数量：
            </div>
            <div class="sign_info-val">
              {{item.no}}
            </div>
          </div>
        </template>
        <div class="sign_item">
          <div class="sign_item-label">
            <img class="sign_icon" src="../../assets/images/sign/icon-lyrs.png" alt="">领用人数：
          </div>
          <div class="sign_info-val">
            {{data.studentNo}}
          </div>
        </div>

      </div>
      <div class="sign_panel sign_clazzlist">
        <div class="sign_item" v-for="item in data.signDetails" :key="item.clazzId" @click="goSignStu(item)">
          <span class="sign_item-label">{{item.clazzName}}</span>
          <div>
            <span class="sign_yq" v-if="item.classSign">已签</span>
            <span class="sign_wq" v-else>未签</span>
            <img class="sign_icon" src="../../assets/images/sign/icon-more.png" alt="">
          </div>
        </div>
      </div>
    </template>
    <div class="sign_invalid" v-else>该链接已失效</div>
  </div>
</template>
<script>
  import './flexible'
  import axios from "axios";
  import Toast from "./toast.js";

  export default {
    name: 'ClazzList',
    data() {
      return {
        data: {
          outputDetails: [],
          signDetails: [],
        },
        isInvalid: false
      }
    },

    beforeRouteEnter(to, from, next) {
      next(vm => {
        console.log(from)
        let outId = to.query.outId
        if (from.name === null) {
          axios.get(`${process.env.SIGN_API_ROOT}/ims/storage-output/sign/${outId}`).then((res) => {
            if (res.data.errCode === '00') {
              vm.data = res.data.data
            } else if (res.data.errCode === '01') {
              vm.isInvalid = true
            } else {
              Toast(res.data.errMsg)
            }
          }, err => {
            Toast('出错了')
          })
        } else if (to.query.signed === 'signed') {
          let clazz = vm.data.signDetails.find(item => item.clazzId === to.query.clazzId) || {}
          clazz.classSign = true
          clazz.signRole = to.query.role
          clazz.signPhone = to.query.phone
          clazz.signUrl = to.params.url
        }
      })

    },
    methods: {
      goSignStu(clazz) {
        this.$router.push({
          name: 'SignStudent', params: {
            clazzId: clazz.clazzId,
            clazzName: clazz.clazzName,
            studentNames: clazz.studentNames,
            outputDetail: this.data.outputDetails[0] || {},
            outDate: this.data.outDate.split(' ')[0],
            orderId: this.data.orderId,
            outId: this.data.outId,
            isSigned: clazz.classSign,
            signRole: clazz.signRole,
            signPhone: clazz.signPhone,
            url: clazz.signUrl
          }
        })
      }
    }
  }
</script>
<style scoped>
  .sign {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #f8f8f8;
    overflow: auto;
    display: flex;
    flex-direction: column;
  }

  .sign_invalid {
    font-size: .4rem;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .sign_head {
    height: 1rem;
    line-height: 1rem;
    background: #ffffff;
    text-align: center;
    font-size: 0.4rem;
    border-bottom: .013rem solid #c7c7c7;
    flex: 0;
  }

  .sign_panel {
    margin: .26rem auto;
    padding: .13rem .4rem;
    width: 92%;
    border-radius: .125rem;
    background: #ffffff;
    box-sizing: border-box;
    color: #666666;
    font-size: .34rem;
  }

  .sign_info {
    margin: .26rem auto .4rem;
  }

  .sign_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .sign_info .sign_item {
    height: .88rem;
  }

  .sign_info .sign_item-label {
    color: #666666
  }

  .sign_icon {
    width: .32rem;
    margin-top: -.05rem;
    margin-right: .13rem;
  }

  .sign_info-val {
    font-size: 0.4rem;
    color: #333333;
  }

  .sign_clazzlist {
    margin-bottom: .5rem;
  }

  .sign_clazzlist .sign_item {
    height: .96rem;
    border-bottom: .013rem solid #f6f6f6;
  }

  .sign_clazzlist .sign_item:last-child {
    border-bottom: none;
  }

  .sign_clazzlist .sign_item .sign_item-label {
    color: #333333;
    font-size: .37rem;
  }

  .sign_clazzlist .sign_yq {
    font-size: .32rem;
    color: #666666;
    padding-right: .4rem;
  }

  .sign_clazzlist .sign_wq {
    font-size: .32rem;
    color: #fd1919;
    padding-right: .4rem;
  }
</style>



// WEBPACK FOOTER //
// Clazz.vue?23322d7c